import { render, staticRenderFns } from "./settings_loose_ends_a.vue?vue&type=template&id=72c9ab63&scoped=true&"
import script from "./settings_loose_ends_a.vue?vue&type=script&lang=js&"
export * from "./settings_loose_ends_a.vue?vue&type=script&lang=js&"
import style0 from "./settings_loose_ends_a.vue?vue&type=style&index=0&id=72c9ab63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9ab63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VCard,VCardText,VCol,VContainer,VRangeSlider,VRow,VSubheader,VTextField})
